<template>
  <div class="quick-menu">
    <ul>
      <li>
        <a href="https://www.pulip.com/project" @click.prevent.stop="showStartProject">{{ $t('common.menu.quickLink')[0] }}</a>
      </li>
      <li>
        <a href="https://www.pulip.com/team" @click.prevent.stop="showRecruit">{{ $t('common.menu.quickLink')[1] }}</a>
        <!--        <span class="teamNum">3</span>-->
      </li>
      <li>
        <a href="/pds" @click.prevent.stop="showPds">{{ $t('common.menu.quickLink')[2] }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import common from '@/shared/mixin/common.js';
export default {
  mixins: [common],
  name: 'QuickMenu',
  methods: {}
};
</script>
